import styled from 'styled-components';
import { withTheme } from '@material-ui/core';

export const BookingBox = withTheme(styled('div')`
  border: 2px solid ${({ theme }) => theme.palette.grey['400']};
  padding: 15px 20px;
  margin-bottom: 16px;
`);
